import Validator from '@shared/validatorjs/src/validator'
import {
  UpdateField,
  SetDefaultData,
  CreateImageTypeRequest,
} from './../image-types.actions'
import { getCreateImageTypeState } from './../image-types.selectors'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subscription } from 'rxjs'
import { Map } from 'immutable'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-create-image-type',
  templateUrl: './create-image-type.component.html',
  styleUrls: ['./create-image-type.component.css'],
})
export class CreateImageTypeComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  public isLoading: boolean
  public for: number
  public radioOptions: any[] = []

  constructor(
    public store: Store<any>,
    private translateService: TranslateService,
  ) {
    super()
  }

  ngOnInit() {
    this.radioOptions = [
      {
        label: this.translateService.instant('PROPERTY'),
        value: 1,
      },
      {
        label: this.translateService.instant('BUSINESS'),
        value: 2,
      },
      {
        label: this.translateService.instant('BOTH'),
        value: 3,
      },
      {
        label: this.translateService.instant('NONE'),
        value: 4,
      },
    ]
    
    this.store.dispatch<any>(new SetDefaultData('createImageType'))
    this.state$ = this.store
      .pipe(select(getCreateImageTypeState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')

        if (
          state.getIn(['data', 'forBusiness']) &&
          state.getIn(['data', 'forProperty'])
        ) {
          this.for = 3
        } else if (state.getIn(['data', 'forBusiness'])) {
          this.for = 2
        } else if (state.getIn(['data', 'forProperty'])) {
          this.for = 1
        } else if (
          !state.getIn(['data', 'forBusiness']) &&
          !state.getIn(['data', 'forProperty'])
        ) {
          this.for = 4
        }
      })
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    if (name === 'for') {
      if (e === 1) {
        this.store.dispatch(
          new UpdateField('forProperty', true, 'createImageType.data'),
        )
        this.store.dispatch(
          new UpdateField('forBusiness', null, 'createImageType.data'),
        )
      } else if (e === 2) {
        this.store.dispatch(
          new UpdateField('forProperty', null, 'createImageType.data'),
        )
        this.store.dispatch(
          new UpdateField('forBusiness', true, 'createImageType.data'),
        )
      } else if (e === 3) {
        this.store.dispatch(
          new UpdateField('forProperty', true, 'createImageType.data'),
        )
        this.store.dispatch(
          new UpdateField('forBusiness', true, 'createImageType.data'),
        )
      } else if (e === 4) {
        this.store.dispatch(
          new UpdateField('forProperty', null, 'createImageType.data'),
        )
        this.store.dispatch(
          new UpdateField('forBusiness', null, 'createImageType.data'),
        )
      }
    } else {
      this.store.dispatch(
        new UpdateField(
          name || e.target.name,
          name ? e : e.target.value,
          'createImageType.data',
        ),
      )
    }

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'createImageType',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      name: 'required',
      title: 'required',
    }
    const validator = new Validator(data.toJS(), rules)

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()
    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new CreateImageTypeRequest(payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'createImageType',
        ),
      )
    }
  }
}
